import { AddBrandFanGroupMemberActionTypes } from '@store/brandFans'

export const addBrandFanGroupMember = (
  identityId: number,
  groupId: number,
  params?: {
    campaignId?: number
    submissionId?: number
    influencerId?: number
    refetchIdentity?: boolean
  },
) => ({
  payload: { identityId, groupId, ...params },
  type: AddBrandFanGroupMemberActionTypes.ADD_MEMBER_REQUEST,
})

export const addBrandFanGroupMemberSuccess = (identityId: number, groupId: number) => ({
  payload: { identityId, groupId },
  type: AddBrandFanGroupMemberActionTypes.ADD_MEMBER_SUCCESS,
})

export const addBrandFanGroupMemberError = (groupId: number, error: any) => ({
  payload: { groupId, error },
  type: AddBrandFanGroupMemberActionTypes.ADD_MEMBER_ERROR,
})
